export default {"src":"/_next/static/media/caret-down.20fd87aa.svg","height":8,"width":12};